import { Layer, Border, BorderPosition } from 'modules/shares/types'
import { rectUnion, rectOffset, rectInset } from 'utils/geometry'

const borderThicknessToExcludeFromSelection = (border: Border): number => {
  if (!border.isEnabled) {
    return 0
  }

  switch (border.position) {
    case BorderPosition.Outside:
      return border.thickness

    case BorderPosition.Center:
      return border.thickness / 2

    case BorderPosition.Inside:
      return 0
  }
}

const thicknessOfThickestBorder = (layer: Layer): number =>
  layer.style?.borders?.reduce(
    (thickness, border) =>
      Math.max(thickness, borderThicknessToExcludeFromSelection(border)),
    0
  ) || 0

const positionLayersOnFauxArtboard = (layers: {
  [key: string]: Layer
}): { [key: string]: Layer } => {
  const layerList = Object.values(layers)

  if (layerList.length <= 0) {
    return layers
  }
  const artboardFrame = layerList.reduce((frame, layer) => {
    const borderThickness = thicknessOfThickestBorder(layer)
    return rectUnion(
      frame,
      rectInset(layer.frame, -borderThickness, -borderThickness)
    )
  }, layerList[0].frame)

  return layerList.reduce((layers, layer) => {
    layer.frame = rectOffset(layer.frame, -artboardFrame.x, -artboardFrame.y)
    layers[layer.id as string] = layer
    return layers
  }, {} as { [key: string]: Layer })
}

export default positionLayersOnFauxArtboard
